import { render } from "./AskForge.vue?vue&type=template&id=6c54fd90&scoped=true&ts=true"
import script from "./AskForge.vue?vue&type=script&lang=ts"
export * from "./AskForge.vue?vue&type=script&lang=ts"

import "./AskForge.vue?vue&type=style&index=0&id=6c54fd90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c54fd90"]])

export default __exports__